import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-bottom: ", ";\n"]);

  _templateObject8 = function () {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: ", ";\n"]);

  _templateObject7 = function () {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-left: 0;\n\tpadding-right: 0;\n"]);

  _templateObject6 = function () {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\t& + & {\n\t\tborder-top: none;\n\t}\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding-bottom: 0;\n\tpadding-top: ", ";\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tcursor: pointer;\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\toutline: none;\n\tpadding: ", ";\n\tposition: relative;\n\n\t&:focus {\n\t\t", ";\n\t\tbox-shadow: 0 0 0 1px ", " inset;\n\t}\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t& + & {\n\t\tborder-top: 1px solid ", ";\n\t}\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var Panel = css(_templateObject(), ui.get('colorDivider'));
export var PanelHeader = css(_templateObject2(), ui.get('panelHeaderPadding'), ui.zIndex('ControlFocus'), ui.color.admin);
export var collapsibleHeader = css(_templateObject3());
export var nonCollapsibleHeader = css(_templateObject4(), ui.space(3));
export var borderless = css(_templateObject5());
export var seamless = css(_templateObject6());
export var PanelBodyView = styled.div(_templateObject7(), ui.get('panelBodyPadding'));
export var nonCollapsibleBody = css(_templateObject8(), ui.space(5));